"use client";
const P = [
  "BaaS",
  "SaaS",
  "PaaS",
  "IaaS",
  "HTML",
  "JSON",
  "HTTPS",
  "HTTP",
  "SMTP",
  "DBMS",
  "RDBMS",
  "REST",
  "SOAP",
  "MVVM",
  "VoIP",
  "RFID",
  "WYSIWYG",
  "WLAN",
  "OIDC",
  "SAML",
  "LDAP",
  "IPSec",
  "OAuth",
  "OpenID",
  "SFTP",
  "IMAP",
  "RTSP",
  "DHCP",
  "XMPP",
  "SNMP",
  "ICMP",
  "IGMP",
  "RARP",
  "PPTP",
  "L2TP",
  "IPv4",
  "IPv6",
  "TOTP",
  "HMAC",
  "TFTP",
  "CORS",
  "CSRF",
  "DDOS",
  "YAML",
  "MQTT",
  "AMQP",
  "HDLC",
  "EDIFACT",
  "DICOM",
  "MATLAB",
  "UNIX",
  "HDMI",
  "WiFi",
  "WPA2",
  "DDoS",
  "ipadOS",
  "watchOS",
  "macOS",
  "JavaScript",
  "TypeScript",
  "SSO",
  "IDP",
  "RBAC"
];
export {
  P as long
};
